import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonIndent
  from 'components/atoms/Editors/EditorMenuButtonIndent/EditorMenuButtonIndent.styles';
import {useRichTextEditorContext} from 'mui-tiptap';

const EditorMenuButtonIndent = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonIndent');

  const editor = useRichTextEditorContext();
  const canSinkListItem = editor.can().sinkListItem('listItem');
  const canSinkTaskItem = editor.can().sinkListItem('taskItem');

  return <StyledEditorMenuButtonIndent buttonRef={ref} {...innerProps}
                                       disabled={!editor?.isEditable || !(canSinkListItem || canSinkTaskItem)}
                                       onClick={() => {
                                         if (canSinkListItem) {
                                           editor?.chain().focus().sinkListItem('listItem').run();
                                         } else {
                                           editor?.chain().focus().sinkListItem('taskItem').run();
                                         }
                                       }}/>
});

EditorMenuButtonIndent.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonIndent;
